/*
 * @Author: houmy
 * @Date: 2023-08-29 18:44:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-16 17:23:03
 * @FilePath: \zx-home\src\main.js
 * @Description: 
 * 
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/css/common.css'
import '@/assets/css/style.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import axios from 'axios'
// import VueAxios from 'vue-axios'
Vue.use(ElementUI)

Vue.config.productionTip = false

import VueAwesomeSwiper from 'vue-awesome-swiper'
 
//引入样式
import 'swiper/css/swiper.css'
 
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)


import VideoPlayer from 'vue-video-player/src'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

// import Vue from 'vue';
// 	import "swiper/swiper.min.css"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js